mutation CancelEvent($input: CancelEventInput!) {
  cancelEvent(input: $input) {
    id
    eventCancel {
      startedAt
      finishedAt
      message
    }
  }
}
